// frontend/src/pages/WebBlocking/index.js
import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
//import SeverityTiles from "./SecurityTiles";
import WebFilteringPolicies from "./WebFilteringPolicies";

const WebBlocking = () => {
  document.title = "Web Blocking Management";

  const headingIconChip = {
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(255, 91, 0, 0.12)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Page Header */}
          <Row className="mb-4">
            <Col xs={12}>
              <div className="d-flex align-items-center justify-content-between ">
                <div>
                  <h4 className="fw-bold mb-1 text-body">
                    <span style={headingIconChip} className="me-2">
                    <FeatherIcon
                      icon="shield"
                      size={18}
                      className=" text-primary"
                    /></span>
                    Web Blocking & Security Dashboard
                  </h4>

                  <p className="text-body-secondary mb-0">
                    Monitor and manage web filtering across your network
                  </p>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center">
                    <div
                      className="bg-success rounded-circle me-2"
                      style={{ width: "8px", height: "8px" }}
                    ></div>
                    <small className="text-success fw-medium">
                      System Active
                    </small>
                  </div>

                  <small className="text-body-secondary">
                    {new Date().toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </small>
                </div>
              </div>

              <hr className="my-3 border-secondary-subtle" />
            </Col>
          </Row>

          {/* Security Tiles */}
         {/* <Row className="mb-4">
            <Col xs={12}>
              <SeverityTiles />
            </Col>
          </Row>*/}

          {/* Web Filtering Management */}
          <Row className="mb-4">
            <Col xs={12}>
              <WebFilteringPolicies />
            </Col>
          </Row>

          {/* Footer Info */}
          <Row>
            <Col xs={12}>
              <Card className="border-0 bg-body-secondary">
                <CardBody className="py-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center text-body-secondary">
                      <FeatherIcon icon="primary" size={14} className="me-2" />
                      <small>
                        All blocking activities are logged and monitored in
                        real-time. Changes propagate within 30 seconds.
                      </small>
                    </div>

                    <div className="d-flex align-items-center gap-3 text-body-secondary">
                      <small className="d-flex align-items-center">
                        <FeatherIcon icon="database" size={12} className="me-1" />
                        DB Connected
                      </small>

                      <small className="d-flex align-items-center">
                        <FeatherIcon icon="wifi" size={12} className="me-1" />
                        API Online
                      </small>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default WebBlocking;
